import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  Container, 
  Box, 
  Typography, 
  Alert, 
  Button 
} from '@mui/material';
import { 
  Cancel as CancelIcon,
  Home as HomeIcon
} from '@mui/icons-material';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Auto-redirect after a delay
    const timer = setTimeout(() => {
      navigate('/', { replace: true });
    }, 10000); // 10 seconds

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box sx={{ textAlign: 'center' }}>
        {/* Cancel Icon */}
        <CancelIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />
        
        <Typography variant="h3" component="h1" sx={{ fontWeight: 'bold', mb: 2, color: 'warning.main' }}>
          Booking Cancelled
        </Typography>
        
        <Typography variant="h6" color="text.secondary" sx={{ mb: 4 }}>
          Your payment was cancelled and no booking has been created
        </Typography>

        {/* Information Alert */}
        <Alert severity="info" sx={{ mb: 4, textAlign: 'left' }}>
          <Typography variant="body2" sx={{ fontWeight: 'medium', mb: 1 }}>
            What happened?
          </Typography>
          <Typography variant="body2">
            You cancelled the payment process or closed the payment window. No charges have been made to your account 
            and your appointment slot is still available for booking.
          </Typography>
        </Alert>

        {/* Action Button */}
        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
          <Button 
            variant="contained" 
            color="primary"
            startIcon={<HomeIcon />}
            onClick={() => navigate('/')}
            sx={{ minWidth: 150 }}
          >
            Start Over
          </Button>
        </Box>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 3 }}>
          You will be automatically redirected to start a new booking in 10 seconds
        </Typography>
      </Box>
    </Container>
  );
};

export default PaymentCancelPage;